import { DateTime } from "luxon";

import { StoppageTypeDto } from "./StoppageTypeDto";
import { StoppageSubTypeDto } from "./StoppageSubTypeDto";
import { LocationDTO } from "../Production/LocationDTO";
import { PlantDTO } from "../Plants/PlantDTO";

export class StoppageDto {
  stoppageId?: number;
  plantId!: number;
  plant?: PlantDTO;
  startTime!: DateTime;
  endTime?: DateTime;
  workOrder?: string;
  repairsFaults?: string;
  whoWorkedOnIt?: string;
  bookedUpBy?: string;
  bookedUpDateTime?: DateTime;
  stoppageTypeId!: number;
  stoppageType?: StoppageTypeDto;
  stoppageSubTypeId!: number;
  stoppageSubType?: StoppageSubTypeDto;
	incident!: boolean;
	locationId?: number;
  location?: LocationDTO;
  hasImages?: boolean;
  rowVersion?: string;

  constructor(data: StoppageDto) {
    Object.assign(this, data);
  }
}
